import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsInteger
*  Настройки целочисленного атрибута
*/
export class AttributeRequirementsInteger extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Integer' })
  readonly type: string = 'Integer'


  /**
  * minValue
  * Минимальное допустимое значение  */
  @ActiveField()
  minValue?: null | number


  /**
  * maxValue
  * Максимальное допустимое значение  */
  @ActiveField()
  maxValue?: null | number
}
